export default __webpack_public_path__ + "static/media/clawsofcorruption.53bc0412.png";